import * as actionTypes from '../actions/actionTypes';

const initialState = {
    groups: null,
    selectedGroupID: null,
    week: null,
    year: null,
    neededDate: '',
    daysFilterApplied: false,
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_SHOP_SUCCEEDED:
            return {
                ...state,
                groups: null,
                selectedGroupID: null,
                week: null,
                year: null
            };
        case actionTypes.GET_GROUPS:
            return {
                ...state,
                selectedGroupID: null
            };
        case actionTypes.GET_GROUPS_SUCCEEDED:
            const {groups, week, year} = action;

            return {
                ...state,
                groups,
                week: week || state.week,
                year: year || state.year
            };
        case actionTypes.SELECT_GROUP:
            const {groupID: selectedGroupID} = action;
            return {
                ...state,
                selectedGroupID
            };
        case actionTypes.SET_DATE_FILTER:
            return {
                ...state,
                neededDate: action.neededDate,
                daysFilterApplied: action.daysFilterApplied,
            };
        default:
            return {
                ...state
            };
    }
};

export default reducer;
